import React, {useState} from 'react'
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { useNavigateTo } from "../../v1/components/live/hooks/useNavigateTo.js";
import { useEffect } from "react";
import SportEventList from "./SportEventList.js";
import { useLiveResolver } from "../hooks/useLiveResolver.js";
import Filter from "./Filter.js";
import CalendarNavigation from '../components/calendar/CalendarNavigation.js';

const CalendarDetail = () => {


    const navigate = useNavigate();

    const navigateTo = useNavigateTo();
    const { id, date } = useParams();

    const queryParameters = new URLSearchParams(window.location.search)
    const sport = queryParameters.get("sport")

    const {liveDates, liveCompetitionsDays} = useOutletContext();

    const [live] = useLiveResolver(id, date)

    const navigateToNewDate = (newDate) => {

        const newPath = window.location.pathname.replace(/\/calendar\/[^/]+/, `/calendar/${newDate}`);

        navigateTo(newPath);
    };

    const handleSportChange = (event) => {

        const currentUrl = new URL(window.location);

        // Utiliser URLSearchParams pour travailler avec les paramètres de requête
        const searchParams = currentUrl.searchParams;

        // Définir ou changer le paramètre 'sport'
        searchParams.set('sport', event);

        // Mettre à jour l'objet searchParams sur l'objet URL
        currentUrl.search = searchParams.toString();

        // Utiliser `navigate` de react-router pour changer l'URL sans recharger la page
        navigateTo('', {sport : event});
    };

    const handleSportClear = () => {
        // Utiliser `navigate` de react-router pour changer l'URL sans recharger la page
        navigateTo('', {}, ['sport']);
    }

    if(!live)
        return <CircularProgress />

    return <Box>
        <CalendarNavigation liveDates={liveDates} activeDate={date} setActiveDate={navigateToNewDate} />
        <Box sx={{ minWidth: '100%', display : 'flex', flexDirection : 'column', alignItems : 'center', justifyContent : 'center', pt : 3, pb : 1 }}>
            <Typography sx={{fontSize : '1.6em', fontWeight : 'bold', textTransform : 'uppercase'}}>{live.name}</Typography>
            {/*<Button onClick={navigateToCustomArticle} sx={{color : 'blue'}}>Accédez à notre direct du jour</Button>*/}
            <Filter sportsList={live.getSportsList()} selectedSport={sport} setSelectedSport={handleSportChange} clearSport={handleSportClear}/>
        </Box>
        <SportEventList events={live.sportEvents.filter(event => !sport || event.phase?.competitionDiscipline?.discipline?.sport?.label === sport).sort((a, b) => new Date(a.date) - new Date(b.date))}
        selectedSport={sport}
        ></SportEventList>
    </Box>
};

export default CalendarDetail